import { api } from '../../../axiosConfig';
import { SurveysAPI } from '../../../API';
import { surveysURL } from '../../../Utils/urls';
import { exportToExcel } from '../../../Utils/ExportToExcel';

// Fieldwork tab exports. Same endpoints, payloads and file names as the
// DashboardDetails handlers (handleExport, downloadPartnerUsersFunc); the id is
// the selected scope: the parent for all markets, or one child survey.

// getSurveyDetailsExport streams CSV; exportType 'panelist' keeps panelist rows only.
export const downloadSurveyUsers = async (surveyId: string, exportType?: 'panelist'): Promise<void> => {
  const qs = exportType ? `?exportType=${encodeURIComponent(exportType)}` : '';
  const resp = await api.get(`${surveysURL}/getSurveyDetailsExport/${surveyId}${qs}`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(resp.data as Blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `survey-${surveyId}${exportType === 'panelist' ? '-panelists' : '-users'}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// An empty export still downloads a headers-only sheet.
const PARTNER_EXPORT_HEADERS = {
  'Project': '', 'Country': '', 'Partner Name': '', 'User Id': '', 'DX User Id': '',
  'Name': '', 'Gender': '', 'Partner RID': '', 'Status': '', 'Survey Type': '',
  'Start IP': '', 'End IP': '', 'Device Type': '',
  'Started At': '', 'Completed At': '', 'LOI (Minutes)': '', 'Substituted Survey Link': '',
};

export const downloadPartnerUsers = async (
  surveyId: string,
  partner: { partnerId: string; partner_name?: string },
  projectId?: string,
): Promise<void> => {
  const respo = await SurveysAPI.getPartnerUsersexport({ id: surveyId, partnerId: partner.partnerId });
  const rows = Array.isArray(respo) ? respo : [];
  const safe = (v: string) => v.replace(/[^a-zA-Z0-9._-]+/g, '_');
  const filename = `${safe(String(projectId || surveyId))}_${safe(String(partner.partner_name || partner.partnerId))}_export`;
  exportToExcel(rows.length ? rows : [PARTNER_EXPORT_HEADERS], filename);
};
